module.exports = __webpack_public_path__ + "static/media/action-notification.87eb7853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notifications/action-notification.png
// module id = 1260
// module chunks = 0